"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var components_1 = require("stremio/components");
var client_1 = __importDefault(require("stremio/caroline/auth/client"));
var useCarolineSession_1 = __importDefault(require("stremio/caroline/auth/useCarolineSession"));
var components_2 = require("../components");
var Account_less_1 = __importDefault(require("./Account.less"));
var Account = (0, react_1.forwardRef)(function (_, ref) {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var session = (0, useCarolineSession_1.default)();
    var _c = (0, react_1.useState)(false), signingOut = _c[0], setSigningOut = _c[1];
    var _d = (0, react_1.useState)(null), error = _d[0], setError = _d[1];
    var onSignOut = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, _1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError(null);
                    setSigningOut(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, client_1.default.signOut()];
                case 2:
                    result = _a.sent();
                    if (result.error) {
                        setError(t('CAROLINE_AUTH_SIGN_OUT_FAILED', { defaultValue: 'Não foi possível terminar a sessão. Tenta novamente.' }));
                    }
                    return [3 /*break*/, 5];
                case 3:
                    _1 = _a.sent();
                    setError(t('CAROLINE_AUTH_UNAVAILABLE', { defaultValue: 'O serviço Caroline Auth não está disponível.' }));
                    return [3 /*break*/, 5];
                case 4:
                    setSigningOut(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(components_2.Section, { ref: ref, label: t('CAROLINE_SETTINGS_ACCOUNT', { defaultValue: 'Conta' }) },
        react_1.default.createElement("div", { className: Account_less_1.default['account'] },
            session.status === 'authenticated' && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: Account_less_1.default['identity'] },
                    react_1.default.createElement("div", { className: Account_less_1.default['name'] }, ((_a = session.user) === null || _a === void 0 ? void 0 : _a.name) || t('CAROLINE_APP_NAME', { defaultValue: 'Caroline' })),
                    react_1.default.createElement("div", { className: Account_less_1.default['email'] }, (_b = session.user) === null || _b === void 0 ? void 0 : _b.email)),
                react_1.default.createElement(components_1.Button, { className: Account_less_1.default['sign-out'], disabled: signingOut, onClick: onSignOut }, t('CAROLINE_AUTH_SIGN_OUT', { defaultValue: 'Terminar sessão' }))),
            session.status === 'loading' && react_1.default.createElement("p", { role: "status" }, t('CAROLINE_AUTH_CHECKING_SESSION', { defaultValue: 'A verificar sessão Caroline…' })),
            (session.status === 'unavailable' || session.status === 'unauthenticated') && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, session.status === 'unavailable'
                    ? t('CAROLINE_AUTH_UNAVAILABLE', { defaultValue: 'O serviço Caroline Auth não está disponível.' })
                    : t('ANONYMOUS_USER')),
                react_1.default.createElement(components_2.Link, { label: t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' }), href: '#/caroline-auth', target: '_self' })),
            error && react_1.default.createElement("p", { role: "alert", className: Account_less_1.default['error'] }, error),
            session.status === 'authenticated' && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: Account_less_1.default['note'] },
                    t('SETTINGS_CHANGE_PASSWORD'),
                    ": ",
                    t('CAROLINE_ACTION_UNAVAILABLE', { defaultValue: 'Ainda não disponível' })),
                react_1.default.createElement("p", { className: Account_less_1.default['note'] },
                    t('SETTINGS_ACC_DELETE'),
                    ": ",
                    t('CAROLINE_ACTION_UNAVAILABLE', { defaultValue: 'Ainda não disponível' }))),
            react_1.default.createElement("p", { className: Account_less_1.default['note'] },
                t('TERMS_OF_SERVICE'),
                ": ",
                t('CAROLINE_LEGAL_UNPUBLISHED', { defaultValue: 'Ainda não publicado' })),
            react_1.default.createElement("p", { className: Account_less_1.default['note'] },
                t('PRIVACY_POLICY'),
                ": ",
                t('CAROLINE_LEGAL_UNPUBLISHED', { defaultValue: 'Ainda não publicado' })))));
});
exports.default = Account;
